import {
  getOccupationFill,
  getStatusFill,
  getSvgProperties,
  PATH_CENTERY,
  ResourceOccupationStatusEnum,
} from '@jooxter/utils';
import { IJxtUnbookablePicto } from './types';

const JxtUnbookablePicto = ({ radius = 30, occupationStatus, x, y, size, status }: IJxtUnbookablePicto) => {
  const { centerX, centerY, scale, badgeOffset, shouldShowOccupationBadge } = getSvgProperties(
    x,
    y,
    radius,
    size,
    occupationStatus
  );

  return (
    <g>
      <circle cx={centerX} cy={centerY} r={radius} fill={getStatusFill(status)} strokeWidth={radius / 1.9} />

      <path
        d="M11.25 22.75C12.6172 22.75 13.75 21.6562 13.75 20.25C13.75 18.8828 12.6172 17.75 11.25 17.75C9.84375 17.75 8.75 18.8828 8.75 20.25C8.75 21.6562 9.84375 22.75 11.25 22.75ZM28.75 22.75C30.1172 22.75 31.25 21.6562 31.25 20.25C31.25 18.8828 30.1172 17.75 28.75 17.75C27.3438 17.75 26.25 18.8828 26.25 20.25C26.25 21.6562 27.3438 22.75 28.75 22.75ZM30 24H27.5C26.7969 24 26.1719 24.3125 25.7031 24.7422C27.3047 25.6016 28.3984 27.1641 28.6719 29H31.25C31.9141 29 32.5 28.4531 32.5 27.75V26.5C32.5 25.1328 31.3672 24 30 24ZM20 24C22.3828 24 24.375 22.0469 24.375 19.625C24.375 17.2422 22.3828 15.25 20 15.25C17.5781 15.25 15.625 17.2422 15.625 19.625C15.625 22.0469 17.5781 24 20 24ZM22.9688 25.25H22.6562C21.8359 25.6406 20.9375 25.875 20 25.875C19.0234 25.875 18.125 25.6406 17.3047 25.25H16.9922C14.4922 25.25 12.5 27.2812 12.5 29.7812V30.875C12.5 31.9297 13.3203 32.75 14.375 32.75H25.625C26.6406 32.75 27.5 31.9297 27.5 30.875V29.7812C27.5 27.2812 25.4688 25.25 22.9688 25.25ZM14.2578 24.7422C13.7891 24.3125 13.1641 24 12.5 24H10C8.59375 24 7.5 25.1328 7.5 26.5V27.75C7.5 28.4531 8.04688 29 8.75 29H11.2891C11.5625 27.1641 12.6562 25.6016 14.2578 24.7422Z"
        fill="white"
        transform={`
  translate(${centerX}, ${centerY})
  scale(${scale})
  translate(-20, -${PATH_CENTERY})
`}
      />
      {shouldShowOccupationBadge && (
        <>
          <circle
            cx={centerX + badgeOffset}
            cy={centerY - badgeOffset}
            r={radius / 2.3}
            fill={getOccupationFill(occupationStatus)}
            stroke="white"
            strokeWidth={radius / 20}
            data-testid="occupation-badge"
          />

          <path
            d={
              occupationStatus === ResourceOccupationStatusEnum.Occupied
                ? 'M34 9.25C35.3672 9.25 36.5 8.13672 36.5 6.75C36.5 5.38281 35.3672 4.25 34 4.25C32.6133 4.25 31.5 5.38281 31.5 6.75C31.5 8.13672 32.6133 9.25 34 9.25ZM35.7383 9.875H35.4062C34.9766 10.0898 34.5078 10.1875 34 10.1875C33.4922 10.1875 33.0039 10.0898 32.5742 9.875H32.2422C30.7969 9.875 29.625 11.0664 29.625 12.5117V13.3125C29.625 13.8398 30.0352 14.25 30.5625 14.25H37.4375C37.9453 14.25 38.375 13.8398 38.375 13.3125V12.5117C38.375 11.0664 37.1836 9.875 35.7383 9.875Z'
                : 'M34.1561 6C32.9061 6 32.0937 6.51562 31.453 7.4375C31.3437 7.59375 31.3749 7.82812 31.5468 7.9375L32.2187 8.45312C32.3749 8.57812 32.6093 8.54688 32.7343 8.39062C33.1249 7.90625 33.4218 7.625 34.0311 7.625C34.5155 7.625 35.1093 7.92188 35.1093 8.39062C35.1093 8.75 34.8124 8.92188 34.3437 9.1875C33.7811 9.5 33.0468 9.89062 33.0468 10.8594V11C33.0468 11.2188 33.2187 11.375 33.4218 11.375H34.5624C34.7655 11.375 34.9374 11.2188 34.9374 11V10.9219C34.9374 10.25 36.8905 10.2188 36.8905 8.40625C36.8905 7.04688 35.4687 6 34.1561 6ZM33.9999 11.8438C33.3905 11.8438 32.9061 12.3281 32.9061 12.9219C32.9061 13.5156 33.3905 14 33.9999 14C34.5937 14 35.078 13.5156 35.078 12.9219C35.078 12.3281 34.5937 11.8438 33.9999 11.8438Z'
            }
            fill="white"
            transform={`translate(${centerX + badgeOffset}, ${centerY - badgeOffset}) scale(${scale / 1.3}) translate(-34, -10)`}
          />
        </>
      )}
    </g>
  );
};

export default JxtUnbookablePicto;
